import React from 'react'
import {Col, Block} from 'jsxstyle'
import {Palette} from 'lucide-react'
import Tooltip from '../Tooltip/Tooltip'

interface ColorPickerProps {
  onColorChange: (color: string) => void
  onMouseEnter: (name: string) => void
  onMouseLeave: () => void
  hoveredTooltip: string | null
}

const ColorPicker: React.FC<ColorPickerProps> = ({onColorChange, onMouseEnter, onMouseLeave, hoveredTooltip}) => {
  return (
    <Col width="auto">
      <Block
        position="relative"
        props={{
          onMouseEnter: () => onMouseEnter('color'),
          onMouseLeave,
        }}
      >
        <Block
          component="label"
          padding="6px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="4px"
          cursor="pointer"
          backgroundColor={hoveredTooltip === 'color' ? '#f0f0f0' : 'transparent'}
          color="#555"
        >
          <Palette size={16} />
          <input
            type="color"
            id="text-color-picker"
            onChange={(e) => onColorChange(e.currentTarget.value)}
            style={{
              position: 'absolute',
              width: '1px',
              height: '1px',
              overflow: 'hidden',
              clip: 'rect(0, 0, 0, 0)',
            }}
          />
        </Block>
        <Tooltip name="color" hoveredTooltip={hoveredTooltip}>
          Text Color
        </Tooltip>
      </Block>
    </Col>
  )
}

export default ColorPicker
